export const CONTACT_TYPES = {
	linkedin: {
		link: "https://www.linkedin.com/in/dannycarvajal1",
		icon: "fab fa-linkedin",
	},
	github: {
		link: "https://github.com/dannycarvajal",
		icon: "fab fa-github",
	},
	email: {
		link: "mailto:oliverdanielcarvajal@hotmail.com",
		icon: "fas fa-envelope",
	},
	behance: {
		link: "http://www.behance.net/dannycarvajal1",
		icon: "fab fa-behance-square",
	},
	web: {
		// link: "https://www.dannycarvajal.com",
		icon: "fas fa-globe",
	},
};
